import { isAfter } from 'date-fns/isAfter'
import { isBefore } from 'date-fns/isBefore'
import { isEqual } from 'date-fns/isEqual'
import { parseISO } from 'date-fns/parseISO'

export function getTimeslotOrderWindow(openTime: string, closeTime: string, now = new Date()) {
  const opening = parseISO(openTime)
  const closing = parseISO(closeTime)
  const isBeforeOpening = isBefore(now, opening)
  const hasCutoffPassed = isEqual(now, closing) || isAfter(now, closing)
  // Keep this separate from the display flags: invalid boundaries cannot form an open window.
  const isWithinOrderWindow =
    (isEqual(now, opening) || isAfter(now, opening)) && isBefore(now, closing)
  return { isBeforeOpening, hasCutoffPassed, isWithinOrderWindow }
}
